import { Laptop } from '@material-ui/icons';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../Redux/Slices/adminPortalSlice';
import './Charts.css';




let options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '80%',
    plugins: {
        legend: {
            position: 'left',
            display: true,
        },
        title: {
            color: 'rgba(0,0,0,0.7)',
            display: true,
            text: 'Device Usage',
            font: {
                size: 20,
            },
        },
        tooltip: {
            displayColors: true,
            intersect: false,
            callbacks: {
                label: function (context) {
                    return ` ${context.label}: ${context.dataset.data[context.dataIndex]}%`;
                },
            }
        },
    }
};

const Doughnut1 = () => {
    let fetchedData = useSelector(analysisData);
    return (
        <div className="doughnut_Div">
            <Doughnut data={get_data(fetchedData.deviceInfo)} options={options} />
        </div>
    );
}

export default Doughnut1;

function get_data(deviceInfo) {
    let deviceInfo_total = deviceInfo.phones + deviceInfo.tablets + deviceInfo.mediumDevices + deviceInfo.laptop_and_beyond;
    let phones = ((deviceInfo.phones / deviceInfo_total)*100).toFixed(0);
    let tablets = ((deviceInfo.tablets / deviceInfo_total)*100).toFixed(0);
    let mediumDevices = ((deviceInfo.mediumDevices / deviceInfo_total)*100).toFixed(0);
    let laptop_and_beyond = ((deviceInfo.laptop_and_beyond / deviceInfo_total)*100).toFixed(0);

    const data = {
        labels: ['Phones', 'Tablets', 'Medium Devices', 'Laptop & Monitors'],
        datasets: [
            {
                label: 'Device usage',
                data: [phones, tablets, mediumDevices, laptop_and_beyond],
                backgroundColor: [
                    'rgba(0, 230, 118, 0.4)',
                    'rgba(1, 87, 155, 0.4)',
                    'rgba(123, 31, 162, 0.4)',
                    'rgba(255, 234, 0, 0.4)',
                ],
                borderColor: [
                    'rgba(0, 230, 118, 1)',
                    'rgba(1, 87, 155, 1)',
                    'rgba(123, 31, 162, 1)',
                    'rgba(255, 234, 0, 1)',
                ],
                borderWidth: 1.2,
            },
        ],
    };
    return (data);
}